import React from 'react'
import { useField } from 'formik'
import ExperienceCheckbox from './ExperienceCheckbox'

/**
 * Formik-connected ExperienceCheckbox.
 */
const ExperienceCheckboxField = ({ name, label, extra, disabled, ...rest }) => {
  const [field, , helpers] = useField({ name, type: 'checkbox' })

  return (
    <ExperienceCheckbox
      {...rest}
      name={name}
      label={label}
      extra={extra}
      disabled={disabled}
      checked={!!field.value}
      onChange={(e) => {
        helpers.setValue(e.target.checked)
      }}
      onBlur={() => helpers.setTouched(true)}
    />
  )
}

export default ExperienceCheckboxField
